<template>
  <div class="fertilizer">
    <div class="box">
      <img src="./innovative.png" width="460" height="320" alt="Innovative?">
    </div>
    <div class="updated">4 VI 2004</div>
  </div>
</template>

<script>
export default {
  name: "innovative"
};
</script>

<style scoped>
.fertilizer {
  background: #ccc;
}

.box {
  margin-top: -160px;
}

.updated {
  color: #ddd;
}
</style>
